import { Health } from '../api';
import {
  showInnerLoading,
  setQuotationSalud,
  setHealthValue,
  increaseStepByOne
} from '../actions';

export function sendQuoteSalud(quoteAccepted) {
  return function(dispatch, getState) {
    const { health } = getState();
    const {
      annualCost,
      capital,
      disease,
      monthlyCost,
      personAge,
      personBirthdate,
      personEmail,
      personGender,
      personName
    } = health;

    const request = {
      quoteAccepted: quoteAccepted,
      annualCost,
      capital,
      disease: disease === 0 ? 'Enfermedades graves' : 'Oncológico',
      monthlyCost,
      personAge,
      personBirthdate,
      personEmail,
      personGender: personGender === 'M' ? 'Masculino' : 'Femenino',
      personName
    };

    dispatch(setHealthValue('sendMailStatus', null));

    return Health.sendMail(request).then(response => {
      if (response && response.sended === '1') {
        dispatch(setHealthValue('sendMailStatus', true));
        dispatch(increaseStepByOne());
      } else {
        dispatch(setHealthValue('sendMailStatus', false));
      }
    });
  };
}

export function getQuotationSalud() {
  return function(dispatch, getState) {
    const { health } = getState();
    const { capital, disease, personGender, personAge } = health;

    const request = {
      capital,
      disease,
      personGender,
      personAge
    };

    dispatch(showInnerLoading(true));

    return Health.getQuotation(request).then(resQuotation => {
      if (resQuotation && !resQuotation.error) {
        const { annualCost } = resQuotation;
        dispatch(setQuotationSalud(annualCost));
      } else {
        console.log('Error getQuotation SALUD');
      }

      dispatch(showInnerLoading(false));
    });
  };
}
